export const ROUTES = {
  login: '/login',
  signup: '/signup',
  dashboard: '/dashboard',
  leads: '/leads',
  leadDetail: (id = ':id') => `/leads/${id}`,
  inquiries: '/inquiries',
  agencies: '/agencies',
  contacts: '/contacts',
  proposals: '/proposals',
  proposalDetail: (id = ':id') => `/proposals/${id}`,
  followups: '/followups',
  fulfillments: '/fulfillments',
  operations: '/operations',
  hotels: '/hotels',
  services: '/services',
  bookings: '/bookings',
  vouchers: '/vouchers',
  analytics: '/analytics',
  ai: '/ai',
  settings: '/settings',
  brain: '/settings/brain',
  notFound: '/404',
} as const;
